import type { OrderHistoryReportExportParams, OrderHistoryReportParams } from 'washday-sdk';

export const buildOrderHistoryReportExportParams = (
  query: OrderHistoryReportParams,
  timezone?: string
): OrderHistoryReportExportParams => ({
  storeId: query.storeId,
  dateField: query.dateField,
  dateFrom: query.dateFrom,
  dateTo: query.dateTo,
  statuses: query.statuses,
  sequence: query.sequence,
  homeServiceOnly: query.homeServiceOnly,
  sortDirection: query.sortDirection,
  timezone
});
